<template>
  <div
    ref="eventCard"
    class="hspot-card hspotcrd gw_hvr gw_hvr_pointer_coarse_disabled"
    :class="[
      { hspotcrd_bot: bot },
      { hspotcrd_active: active },
      { hspotcrd_skeleton: skeleton },
      { hspotcrd_minimized: minimized },
      { 'hspotcrd_action-vertical': !minimized && isMinimizedVertical },
      { hspotcrd_opentotop: openToTop },
      { hspotcrd_hasnodedit: l_hasNodeEdit },
      { hspotcrd_hasnodelock: l_hasNodeMenu },
    ]"
    :style="cardStyle"
    @mouseenter="handleMouseenter"
    @mouseleave="handleMouseleave"
    @click="handleClick"
  >
    <div class="hspotcrd_inner">
      <div
        v-if="$slots.title"
        class="hspotcrd_title"
      >
        <slot name="title" />
      </div>

      <div
        v-if="$slots.cards || $slots.filter_items || $slots.message || $slots.loading"
        class="hspotcrd_slot"
        :class="{ hspotcrd_slot_cards: $slots.cards || $slots.filter_items }"
      >
        <slot name="loading" />
        <slot name="message" />
        <slot name="filter_items" />
        <slot name="cards" />
      </div>
      <div
        v-if="item && !$slots.message && !$slots.loading ? item.type === 'player' : false"
        class="hspotcrd_actions"
      >
        <div
          v-if="minimized && !item.selected_action_code"
          class="hspotcrd_action_prompt"
          @click="e => handleTakeActionClick(e)"
        >
          {{ $t('event_card.take_action') }}
        </div>
        <div
          v-for="(action, idx) in item.available_actions"
          :key="idx + item.position"
          :style="item.selected_action_code ? getActionStyle(idx, action.is_selected) : ''"
          class="hspotcrd_action"
          :class="[
            action.is_selected
              ? `${
                  item.train_result
                    ? `hspotcrd_action_active action_${item.train_result.res_group}`
                    : 'hspotcrd_action_active'
                }`
              : '',
            { hspotcrd_disabled: actionIsDisabled(action) },
          ]"
          @click="e => handleActionClick(e, action)"
        >
          <i
            v-if="item.hasCorrectnessIcon && action.correctness_group && action.is_selected"
            class="hspotcrd_action_icon mdi"
            :style="`font-size: 1.25em; color:var(${action.correctness_group.color})`"
            :class="action.correctness_group.icon"
          >
          </i>
          <div
            class="hspotcrd_action_text"
            :class="[{ 'gw_hvr_pointer_coarse_disabled opacity_4': actionIsDisabled(action) }]"
            v-html="
              getBetHtml({
                showBetsIn,
                a: action,
                name: true,
                pot_css_class: 'bet-as-pot bet-as-pot-right',
              })
            "
          ></div>
          <div
            v-if="actionIsDisabled(action)"
            class="mdi mdi-information clr-grey csst csst_nm mx-auto cursor-default"
            @mouseenter="e => fl_positionTooltip(e, { placement: 'top' })"
          >
            <div
              class="csst_content text-nowrap clr-white"
              style="position: fixed"
            >
              {{
                betSizeNotFullyLoaded
                  ? $t('tooltips.bet_size_not_available')
                  : $t('tooltips.bet_size_not_used')
              }}
            </div>
          </div>
        </div>
        <i
          v-if="overflowActions && !minimized"
          class="mdi mdi-dots-horizontal hspotcrd_arrow"
        />
      </div>
    </div>

    <div
      v-if="item ? item.hasCorrectnessTooltip && minimized : false"
      ref="freqMenuCont"
      class="hspotcrd_tooltip_trigger"
      data-tst="hspotcrd_tooltip_trigger"
      @mouseenter="handleTooltipMouseenter"
      @mouseleave="handleTooltipMouseleave"
    >
      <GwMenu
        v-if="tooltipOpen"
        ref="gwmenu"
        :referenceEl="referenceEl"
        placement="bottom"
        :closeOnOutsideClick="false"
      >
        <div
          class="gw_box ha-street-blocks"
          style="--gap: 0; padding: 0.5rem; --ha-aa-width: 8rem"
        >
          <HaActionMetrics
            v-for="(action, aIdx) in item.available_actions"
            :key="`${aIdx}_${action.code}`"
            :action="action"
            :isNa="action.correctness === 'na'"
            :hasEv="'ev' in action"
            :showBetsIn="showBetsIn"
            :bettingInfo="bettingInfo || { showEvIn, pot: item.pot }"
            :hasBBPot="true"
            :open="true"
          />
        </div>
      </GwMenu>
    </div>

    <div
      v-if="l_hasNodeMenu"
      class="hspotcrd_editmenu"
    >
      <div
        class="csst csst_nm"
        @mouseenter="e => fl_positionTooltip(e, { placement: 'right' })"
      >
        <div
          class="icon_btn mdi clr-hover mdi-pencil"
          data-tst="icon_edit_node"
          style="font-size: 1.125rem; padding: 0.25rem; color: var(--clr-grey-2)"
          @click="$emit('click:nodeedit', item)"
        ></div>
        <div
          class="csst_content clr-white"
          style="position: fixed"
          v-html="$t('tooltips.edit_node')"
        ></div>
      </div>

      <div
        class="csst csst_nm"
        @mouseenter="e => fl_positionTooltip(e, { placement: 'right' })"
      >
        <ReactComponent
          v-if="$store.getters.user_has_flag('NODELOCK_V2')"
          name="NodeLockButton"
          class="mdi clr-hover"
          style="font-size: 1.125rem"
        />

        <div
          v-else
          class="icon_btn mdi clr-hover"
          data-tst="icon_node_lock"
          style="font-size: 1.125rem; padding: 0.25rem; color: var(--clr-grey-2)"
          :class="[{ 'no-events opacity_4': item.available_actions?.length === 1 }, 'mdi-lock']"
          @click="
            () => {
              if (item.available_actions?.length === 1) return
              $emit('click:nodelock', item)
            }
          "
        />
        <div
          class="csst_content clr-white"
          style="position: fixed"
          v-html="
            item.available_actions?.length === 1
              ? $t('tooltips.node_lock_disabled')
              : $t('tooltips.node_lock')
          "
        />
      </div>
      <div
        class="csst csst_nm"
        @mouseenter="e => fl_positionTooltip(e, { placement: 'right' })"
      >
        <div
          class="icon_btn mdi clr-hover mdi-select-compare"
          data-tst="icon_compare"
          style="font-size: 1.125rem; padding: 0.25rem; color: var(--clr-grey-2)"
          @click="$emit('click:nodecompare', item)"
        ></div>
        <div
          class="csst_content clr-white"
          style="position: fixed"
          v-html="$t('tooltips.node_compare')"
        ></div>
      </div>
    </div>
    <div
      v-else-if="l_hasNodeEdit"
      class="hspotcrd_nodeedit gw_hvr_content"
    >
      <div
        v-if="(item.merged_actions || []).length"
        class="mdi mdi-information clr-grey csst csst_nm mx-auto cursor-default"
        @mouseenter="e => fl_positionTooltip(e, { placement: 'top' })"
      >
        <div
          class="csst_content text-nowrap clr-white"
          style="position: fixed"
          v-html="
            $t('tooltips.merged_actions', {
              str: item.merged_actions.map(i => `${i}bb`).join(', '),
            })
          "
        />
      </div>
      <div
        class="clr-grey clr-hover icon_btn mdi mdi-pencil csst csst_nm"
        style="font-size: 1.125rem; padding: 0.25rem"
        data-tst="hspotcrd_nodeedit"
        @click.stop="$emit('click:nodeedit', item)"
        @mouseenter="e => fl_positionTooltip(e, { placement: 'bottom' })"
      >
        <div
          class="csst_content text-nowrap"
          style="position: fixed"
          v-html="$t('tooltips.edit_node')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import GwMenu from '@/components/lib/GwMenu'
import HaActionMetrics from '@/components/AnalyzeStreetBlocks/HaActionMetrics'
import format_mix from '@/mixins/format_mix'
import float_mix from '@/mixins/float_mix'
import ReactComponent from '@/components/React/ReactComponent.vue'

export default {
  name: 'EventCard',
  components: {
    HaActionMetrics,
    GwMenu,
    ReactComponent,
  },
  mixins: [format_mix, float_mix],
  props: {
    item: Object,
    namespace: { String, required: true },
    bettingInfo: Object,
    minimized: Boolean,
    isMinimizedVertical: Boolean,
    active: Boolean,
    loading: Boolean,
    skeleton: Boolean,
    bot: Boolean,
    mobile: Boolean,
    openToTop: Boolean,
    showBetsIn: String,
    showEvIn: String,
    hasNodeEdit: Boolean,
    hasNodeMenu: Boolean,
    hasDisabledZeroFreqActions: Boolean,
    requiredToGenerateReport: Boolean,
    isCustomReportsPending: Boolean,
  },
  emits: [
    'click:nodeedit',
    'height:diff',
    'click',
    'actionClick',
    'click:nodelock',
    'click:nodecompare',
  ],
  data() {
    return {
      mouseover: false,
      cardStyle: '',
      scrollTimeout: -1,
      tooltipOpen: false,
      referenceEl: null,
    }
  },
  mounted() {
    this.scrollToMe()
  },
  methods: {
    actionIsDisabled(action) {
      return this.hasDisabledZeroFreqActions && 'frequency' in action && !action.frequency
    },
    handleTooltipMouseleave(e) {
      this.tooltipOpen = false
    },
    handleTooltipMouseenter() {
      // trainer shortcut spots can be without metrics
      // const action = this.item.available_actions?.[0] || {}
      // this.tooltipOpen = 'frequency' in action

      // BE can return frequency 0 for all actions
      this.tooltipOpen = (this.item.available_actions || []).some(a => a.frequency)
      if (!this.tooltipOpen) return
      setTimeout(() => {
        this.referenceEl = this.$refs.freqMenuCont
        if (this.$refs.gwmenu) {
          this.$refs.gwmenu.toggleOpen(true)
          // console.log(this.referenceEl)
        }
      })
    },
    handleMouseenter() {
      if (this.minimized) return
      this.toggleEditMenu(true)

      if (this.isMinimizedVertical) return
      if (!this.overflowActions) return
      this.mouseover = true
      const length = this.item?.available_actions?.length
      const newHeight = `calc((${length} * var(--action-height)) + ${this.item.bounty ? '3.75' : '2.25'}em)`
      this.cardStyle = `--height: ${newHeight};`
    },
    handleMouseleave() {
      this.toggleEditMenu(false)
      this.mouseover = false
      if (this.cardStyle) {
        this.cardStyle = ''
      }
    },
    handleClick(e) {
      // active card maximizes, inactive sets spot, action click maximizes
      e.gw_eventCardHandler =
        e.gw_eventCardHandler || (this.active ? 'activeCardClick' : 'inactiveCardClick')
      this.$emit('click', e)
    },
    toggleEditMenu(bool) {
      if (!this.$refs.editmenu) return
      this.$refs.editmenu.toggleOpen(bool)
    },
    handleTakeActionClick(e) {
      e.gw_eventCardHandler = 'takeActionClick'
      this.handleClick(e)
    },
    handleActionClick(e, action) {
      if (this.actionIsDisabled(action)) {
        // Do not handle click for actions that are not available
        return
      }
      if (this.minimized && this.item?.type !== 'board') {
        e.gw_eventCardHandler = 'actionClick'
        this.handleClick(e)
        return
      }
      e.stopPropagation()
      this.$emit('actionClick', action)
    },
    scrollToMeMinimized() {
      if (this.active || this.loading) {
        clearTimeout(this.scrollTimeout)
        this.scrollTimeout = setTimeout(() => {
          this.scrollToCard()
        }, 320)
      }
    },
    scrollToMe() {
      if (this.isMinimizedVertical) {
        this.scrollToMeMinimized()
        return
      }
      if ((this.active || this.loading) && !this.mouseover) {
        clearTimeout(this.scrollTimeout)
        this.scrollTimeout = setTimeout(() => {
          // console.log('scroll-tome')
          this.scrollToCard()
        }, 210)
      }
    },
    scrollToCard() {
      const { eventCard } = this.$refs
      if (eventCard) {
        const scrollCont = document.getElementById(
          `${this.namespace ? `${this.namespace}/` : ''}hspotscont_inner`,
        )
        if (scrollCont) {
          const { left: c_left, right: c_right, top: c_top } = scrollCont.getBoundingClientRect()
          const offsetLeft = eventCard.offsetLeft
          const offsetTop = eventCard.offsetTop
          const { left, right, top } = eventCard.getBoundingClientRect()
          const notFullyVisible = left < c_left || right > c_right || top > c_top
          if (notFullyVisible) {
            scrollCont.scroll({
              top: offsetTop,
              left: offsetLeft,
              behavior: 'smooth',
            })
          }
        }
      }
    },
    getActionStyle(idx, active) {
      if (this.isMinimizedVertical) return ''
      if (this.minimized) return ''
      if (!active || idx < this.visibleActions) {
        return ''
      }
      if (!this.mouseover) {
        const res = {
          top: `calc(-${idx + 1 - this.visibleActions || 1} * var(--action-height)`,
        }
        return res
      }
      return 'top:0;'
    },
    openComparsionDialog() {
      this.$store.dispatch('router_set_dialogs', `comparsion-dialog_namespace-${this.namespace}`)
    },
  },
  computed: {
    isDev() {
      // return import.meta.env.VITE_ENV === 'production'
      // ? import.meta.env.VITE_BRANCH !== 'master' : true
      return import.meta.env.VITE_ENV !== 'production'
    },
    betSizeNotFullyLoaded() {
      return this.requiredToGenerateReport || this.isCustomReportsPending
    },
    canHaveControls() {
      return !this.minimized && this.item.type === 'player' && this.item.available_actions?.length
    },
    l_hasNodeEdit() {
      return this.canHaveControls && this.hasNodeEdit
    },
    l_hasNodeMenu() {
      return this.canHaveControls && this.hasNodeMenu
    },
    // actionLarge() {
    //   return this.mobile && !this.minimized
    // },
    visibleActions() {
      return this.mobile && !this.minimized ? 4 : 5
    },
    overflowActions() {
      const length = this.item?.available_actions?.length
      return length > this.visibleActions
    },
  },
  watch: {
    active: {
      immediate: false,
      handler: 'scrollToMe',
    },
    minimized: {
      immediate: false,
      handler: 'scrollToMeMinimized',
    },
  },
}
</script>

<style lang="scss">
@import '@/styles/mixins.scss';

.hspotcrd {
  --clr-card-primary: var(--clr-hero);

  --clr-card-back: var(--clr-black-1);
  --clr-card-back-hover: var(--clr-black-1-2);
  --clr-card-back-active: var(--clr-black-1-2);

  --border-width: 2px;

  --clr-border: var(--hs-spot-clr-border, var(--clr-card-back));
  // --clr-border: var(--clr-black-2);

  --clr-border-hover: var(--clr-card-primary);
  --clr-border-active: var(--clr-card-primary);

  --clr-title: var(--clr-grey-2);
  --clr-title-hover: var(--clr-card-primary);
  --clr-title-active: var(--clr-card-primary);

  --clr-action: var(--clr-grey-2);
  --clr-action-hover: var(--clr-white-0);
  --clr-action-active: var(--clr-white-0);

  --title-size: 0.875em;
  --action-size: 1em;
  --action-weight: 500;
  --action-letter-spacing: 0px;

  --action-height: 1.25em;

  --clr-action-back: var(--clr-card-back);

  --clr-action-back-hover: var(--clr-black-3);
  --clr-action-back-active: var(--clr-black-3);

  --width: 7.5em;
  --width-with-menu: 9.75em;
  --width-min: 5em;
  --height-min: 2.25em;
  --height: 8.75em;

  overflow: hidden;
  position: relative;
  border-radius: 4px;
  --action-radius: 4px;

  height: var(--height);
  min-width: var(--width);
  transition: height 0.22s;

  flex-shrink: 0;
  border: solid var(--border-width) var(--clr-border);
  background: var(--clr-card-back);

  background-clip: padding-box;
  display: flex;
  &_bot {
    --clr-card-primary: var(--clr-opponent);
  }
  &_inner {
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: inherit;
    overflow: inherit;
    display: flex;
    flex-direction: column;
  }
  &_title {
    display: flex;
    color: var(--clr-title);
    font-size: var(--title-size);
    font-weight: 700;
    padding: 0.25em 0.8em 0.25em 0.8em;
    text-transform: uppercase;
    justify-content: space-between;
    align-items: center;
    // line-height: 1;
    &_stack {
      font-size: 0.875em;
      // line-height: 1.8;
      // line-height: 1;
      font-weight: 700;
      display: flex;
      // height: 1px;
      align-items: center;
    }
  }
  &_slot {
    padding: 0.125em 0.8em;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 100%;
    flex: 1;
    &_cards {
      flex-direction: column;
    }
  }
  &_actions {
    width: 100%;
  }
  &_arrow {
    background: var(--clr-card-back);
    position: absolute;
    bottom: 0rem;
    height: 0.25em;
    width: 100%;
    line-height: 0.25em;
    // background-image: linear-gradient(
    //   180deg,
    //   transparent 0%,
    //   var(--clr-card-back)
    // );
    display: flex;
    // align-items: center;
    align-items: flex-start;
    justify-content: center;
    color: var(--clr-grey-2);
  }
  &_action {
    display: flex;
    align-items: center;
    position: relative;
    top: 0;
    transition: top 0.22s;
    height: var(--action-height);
    line-height: var(--action-height);
    background: var(--clr-action-back);
    border-radius: var(--action-radius);
    margin: 0px 0.25em;
    &_text {
      padding: 0 0.45em;
      font-size: var(--action-size);
      color: var(--clr-action);
      font-weight: var(--action-weight);
      letter-spacing: var(--action-letter-spacing);
      line-height: inherit;
      height: inherit;
      width: 100%;
      display: flex;
      align-items: center;
      white-space: nowrap;
      // text-transform: uppercase;
    }
    &_active {
      --clr-action: var(--clr-action-active);
      --clr-action-back: var(--clr-action-back-active);
    }
    &_icon {
      position: relative;
      right: -0.5rem;
      margin-right: 0.5rem;
    }
  }
  // &_nodemenu {
  // position: absolute !important;
  // inset: 0 0 auto auto;
  // }
  &_nodeedit {
    position: absolute !important;
    inset: -0.125rem -0.125rem auto auto;
    font-size: var(--action-size);
    inset: auto -0.125rem -0.125rem auto;
    background: var(--clr-card-back);
    display: flex;
    flex-direction: column;
    border-radius: 4px;
    padding: 0.25rem;
    opacity: 0;
    gap: 0.25rem;
  }
  &.hspotcrd_active {
    // .hspotcrd_nodemenu,.hspotcrd_nodeedit {
    // opacity: 1 !important;
    // }
    .hspotcrd_nodeedit,
    .hspotcrd_merged-actions-info {
      opacity: 1 !important;
    }
  }
  // &.hspotcrd_opentotop {
  //   .hspotcrd_nodeedit {
  //   }
  // }
  &.hspotcrd_action-vertical {
    --title-size: 1.25em;
    --action-size: 1.5em;
    --action-height: 1.875em;

    height: unset;
    min-height: 4rem;
    width: 100%;
    // padding: 0 0 0.325rem 0;
    .hspotcrd_action:last-child {
      margin-bottom: 0.325rem;
    }
    .hspotcrd_arrow {
      display: none;
    }
  }

  // &_hasnodedit {
  //   padding-bottom: 1rem;
  // }
  &_skeleton {
    // --clr-border: transparent;
    pointer-events: none;
    &:after {
      content: '';
      height: 100%;
      width: 100%;
      background: var(--clr-card-back);
      position: absolute;
      z-index: 2;
      top: 0;
      left: 0;
      // animation: LoadingPulse 2s infinite;
    }

    // @keyframes LoadingPulse {
    //   0% {
    //     background: var(--clr-card-back);
    //   }
    //   50% {
    //     background: var(--clr-black-1-3);
    //   }
    //   100% {
    //     background: var(--clr-card-back);
    //   }
    // }
  }
  &_minimized {
    --height: var(--height-min) !important;
    --width: var(--width-min);
    transition: 0s !important;
    .hspotcrd {
      &_inner {
        display: flex;
        flex-direction: row;
        height: 100%;
      }
      &_title {
        padding: 0 0.5em;
        height: 100%;
        align-items: center;
        &_stack {
          padding: 0 0.25em 0 0.5em;
        }
      }
      &_slot {
        height: 100%;
        padding: 0.25em 0.5em;
        &_cards {
        }
      }
      &_action {
        height: 100%;
        margin: 0;
        // border-radius: 0;
        &:not(.hspotcrd_action_active) {
          display: none;
        }
        &_prompt {
          height: 100%;
          display: flex;
          align-items: center;
          padding: 0 0.5em 0 0.5em;
          color: var(--clr-grey-2);
          // font-size: 0.875em;
          font-weight: 500;
          // font-size: var(--action-size);
          background: var(--clr-black-2);
          // font-weight: 500;
        }
      }
    }
  }
  &_tooltip {
    &_trigger {
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
    }
  }
  &_editmenu {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;

    // border-left: solid var(--clr-black-2) 1px;
    // background: var(--clr-black-1-1);
    // border: solid var(--clr-black-2) 1px;
    // background: var(--clr-black-0-3);
    background: rgba(0, 0, 0, 0.18);
    // background: rgba(0, 0, 0, 0.15);

    border-radius: 4px;

    display: none;

    min-width: 2rem;
    gap: 0.25rem;
    padding: 0.25rem 0;
  }
  // &_lst {
  //   &_hovered {
  //     .hspotcrd_editmenu {
  //       display: flex;
  //     }
  //   }
  // }
  &_active {
    --clr-card-back: var(--clr-card-back-active);
    --clr-title: var(--clr-title-active);
    --clr-border: var(--clr-border-active);
    --clr-action: var(--clr-action-active);
    &.hspotcrd_hasnodelock {
      --width: var(--width-with-menu);
    }

    .hspotcrd_editmenu {
      display: flex;
    }
  }
  &:hover {
    .hspotcrd_arrow {
      display: none;
    }
  }
}

@media (hover: hover) and (pointer: fine) {
  .hspotcrd {
    &:not(.hspotcrd_disabled):hover {
      cursor: pointer;
      --clr-card-back: var(--clr-card-back-hover);
      --clr-title: var(--clr-title-hover);
      --clr-border: var(--clr-border-hover);
      --clr-action: var(--clr-action-active);
      z-index: 4;
    }

    &_action {
      &:not(.hspotcrd_disabled):hover {
        cursor: pointer;
        --clr-action: var(--clr-action-hover);
        --clr-action-back: var(--clr-action-back-hover);
        z-index: 4;
      }
    }
  }

  /* Explicitly prevent hover effects for disabled elements */
  .hspotcrd.hspotcrd_disabled,
  .hspotcrd_action.hspotcrd_disabled {
    cursor: not-allowed; /* Prevents the pointer from changing */
  }
}
</style>
